import { FILE_DOWNLOAD_FORMATS } from '../constants/fileDownloadFormats';

/**
 * Tries to determine the filename based on the Content Disposition header
 * @param {*} disposition Content-Disposition header value
 * @returns
 */
export function getFilenameFromContentDisposition(disposition) {
	if (!disposition) {
		return null;
	}

	// First try filename* (preferred - supports UTF-8 and special chars)
	let filename = null;

	// Match filename*=UTF-8''value or filename*=lang''value (lang optional)
	const utf8Regex = /filename\*\s*=\s*(?:UTF-8''|[\w-]*''|)([^;]*)/i;
	const utf8Match = utf8Regex.exec(disposition);

	if (utf8Match?.[1]) {
		try {
			filename = decodeURIComponent(utf8Match[1].trim());
		} catch (e) {
			console.warn('Failed to decode filename*', e);
		}
	}

	// Fallback to classic filename= if filename* didn't work
	if (!filename) {
		const asciiRegex = /filename\s*=\s*([^;]*)/i;
		const asciiMatch = asciiRegex.exec(disposition);
		if (asciiMatch?.[1]) {
			filename = asciiMatch[1].trim().replace(/^["']|["']$/g, ''); // remove wrapping quotes
		}
	}

	return filename;
}

/**
 * Helper to create a filename based on the prefix and the file format
 * @param {*} prefix - filename without the file extension
 * @param {*} format - format of the file used to derive the extension
 * @returns
 */
export function createDefaultFilename(prefix, format) {
	let fileExtension;
	switch (format.toLowerCase) {
		case FILE_DOWNLOAD_FORMATS.CSV:
			fileExtension = 'csv';
			break;

		case FILE_DOWNLOAD_FORMATS.EXCEL:
			fileExtension = 'xlsx';
			break;

		case FILE_DOWNLOAD_FORMATS.PDF:
			fileExtension = 'pdf';
			break;

		default:
			fileExtension = 'txt';
	}

	return `${prefix}-${new Date().toISOString().slice(0, 10)}.${fileExtension}`;
}
